import type { Element } from "React";
type Props = {
  className?: string;
};

const IconFavIcon = (props: Props): Element<"svg"> => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsxlinkhref="http://www.w3.org/1999/xlink"
    width="20"
    height="20"
    viewBox="0 0 20 20"
  >
    <defs>
      <path id="a" d="M0 4.525h9.717v8.354H0z" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <rect width="20" height="20" fill="#2B393F" rx="10" />
      <g transform="translate(6 4)">
        <path fill="#4DA1A9" d="M0 0v2.415h4.731L6.923 0z" />
        <path
          fill="#FFF"
          d="M5.031 4.856c.553 0 1.115.04 1.597.243L9.31 2.076V0H8.2L4.005 4.718l1.026.138z"
        />
        <mask id="b" fill="#fff">
          <use xlinkHref="#a" />
        </mask>
        <path
          fill="#FFF"
          d="M5.62 12.88H0v-2.437h5.62c.987 0 1.79-.91 1.79-1.915s-.804-1.914-1.792-1.914H2.073l2.129-2.089h1.416c2.26 0 4.099 1.888 4.099 4.177 0 2.29-1.838 4.177-4.097 4.177"
          mask="url(#b)"
        />
      </g>
    </g>
  </svg>
);

export default IconFavIcon;
